import { render, staticRenderFns } from "./DetailLaporanGadaiBaru.vue?vue&type=template&id=b4cf817a&scoped=true&"
import script from "./DetailLaporanGadaiBaru.vue?vue&type=script&lang=js&"
export * from "./DetailLaporanGadaiBaru.vue?vue&type=script&lang=js&"
import style0 from "./DetailLaporanGadaiBaru.vue?vue&type=style&index=0&id=b4cf817a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cf817a",
  null
  
)

export default component.exports